import script from "./WelcomeComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./WelcomeComponent.vue?vue&type=script&setup=true&lang=js"

import "./WelcomeComponent.vue?vue&type=style&index=0&id=f2659972&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f2659972"]])

export default __exports__